import styled from 'styled-components';

export const SearchModalStyles = styled.div`
  position: fixed;
  z-index: 2000;
  min-height: 100vh;
  width: 100%;
  background-color: #000000bd;

  .searchModalOverlay {
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  .modal__container {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 80px;
    max-height: calc(100% - 120px);
    width: 90%;
    max-width: 500px;
    background-color: var(--black-1);
    padding: 4.8rem 2rem 2rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;

    .close {
      position: absolute;
      top: 8px;
      right: 8px;
      z-index: 2;
      width: 36px;
      height: 36px;
      padding: 0;
      border-color: rgb(85, 128, 170);
      color: rgb(85, 128, 170);
      background-color: var(--white);
      &:hover {
        background-color: rgb(85, 128, 170);
        color: var(--white);
      }
    }

    .search__result {
      margin-top: 2rem;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      width: 100%;
      overflow-y: auto;
    }
  }

  @media only screen and (max-width: 768px) {
    .modal__container {
      top: 60px;
      padding: 4.4rem 1.5rem 1.5rem;
      max-height: calc(100% - 80px);
    }
  }

  @media only screen and (max-width: 480px) {
    .modal__container {
      top: 20px;
      width: 95%;
      padding: 4.2rem 1.25rem 1.25rem;
      max-height: calc(100% - 40px);
    }
  }
`;
